<template>
  <div class="text-center">
    <v-dialog scrollable v-model="dialog" ref="dlgInfo" width="650">
      <template v-slot:activator="{}"></template>

      <v-card>
        <v-card-title class="headline">Bantuan</v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="2" sm="2" md="1" lg="1" xl="1">
              <v-icon class="text-h3 primary--text">mdi-help-circle</v-icon>
            </v-col>
            <v-col cols="10" sm="10" md="10" lg="10" xl="10">
              <div class="text-left mb-0 pb-0" v-if="current_instansi.id === 57">
                <p>
                  Kami siap membantu! Apabila Anda mengalami kesulitan dalam proses pendaftaran, pembelajaran, atau kendala teknis lainnya, silakan hubungi tim dukungan kami
                  melalui email:
                  <a href="mailto:ratna.nurlaila@kemdikbud.go.id?subject=Dukungan%20Aplikasi">ratna.nurlaila@kemdikbud.go.id</a>
                  atau
                  <a href="mailto:meilia2701@gmail.com?subject=Dukungan%20Aplikasi">meilia2701@gmail.com</a>.
                  <br />
                  Terima Kasih
                </p>
              </div>
              <div class="text-left mb-0 pb-0" v-else>
                <p>Gunakan tautan bantuan dibawah ini jika terjadi kendala selama proses pembelajaran</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black--text" text @click="closeGuide">Tutup</v-btn>
          <v-btn color="primary" v-if="current_instansi.id != 57" @click="toJoin" :loading="loading">Bantuan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//@group Global Feature
export default {
  name: "home-form-join-telegram",
  data() {
    return {
      dialog: false,
      config: null,
      loading: false
    };
  },

  methods: {
    //@vuese
    //buka dialog dan ambil data konfigurasi telegram
    // eslint-disable-next-line
    open() {
      this.dialog = true;
      this.loadConfig();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    //@vuese
    //tutup dialog
    closeGuide() {
      this.dialog = false;
      this.resolve();
    },
    //@vuese
    //buka link join telegram sesuai konfigurasi
    toJoin() {
      window.open(this.current_instansi && this.current_instansi.url_telegram ? this.current_instansi.url_telegram : this.config.string, "_blank");
      this.dialog = false;
      this.resolve();
    },
    //@vuese
    //ambil data konfigurasi telegram
    loadConfig() {
      this.loading = true;
      return this.$store
        .dispatch("instansi/config", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          var configTelegram = res.filter(r => (r.key = "url_telegram"));
          this.config = configTelegram && configTelegram.length > 0 ? configTelegram[0] : null;
          this.loading = false;
        })
        .catch(e => e);
    }
  }
};
</script>
